export default {
  namespaced: true,
  state: {
    auth_token: null,
    back_url: null,
    locale: 'de',
    user: null,
    mandate: null,
  },
  mutations: {
    SET_MANDATE(state, mandate) {
      state.mandate = mandate;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_AUTH_TOKEN(state, authToken) {
      state.auth_token = authToken;
    },
    SET_BACK_URL(state, backUrl) {
      state.back_url = backUrl;
    },
    SET_LCOALE(state, locale) {
      state.locale = locale;
    },
  },
  actions: {
    setParams({ commit }, params) {
      const claims = JSON.parse(atob(params.auth_token.split('.')[1]));
      const user = {
        id: claims.uid,
        name: params.user_name,
      };
      const mandate = {
        id: claims.mid,
        name: params.mandate_name,
        slug: params.mandate_slug,
      };
      commit('SET_MANDATE', mandate);
      commit('SET_USER', user);
      commit('SET_AUTH_TOKEN', params.auth_token);
      commit('SET_BACK_URL', params.back_url);
      commit('SET_LCOALE', params.locale);
    },
  },
};
